module.exports = __webpack_public_path__ + "static/media/features-split-image-02.806946d0.jpg";